<script>

  import sgsUtils from './SgsUtils'

  export default{
    props: [
      "attr", "fieldValue", "rules", "label",
      "showHint", "hintValue", "moduleType"
    ],
    data(){
      return {
        config: {
          placeholderText: '',
          //height: 300,
          quickInsertButtons: ['embedly', 'table', 'ul', 'ol', 'hr'],
          toolbarButtons: [
            'fullscreen',
            'undo',
            'redo', '|',
            'bold',
            'italic',
            'underline',
            'strikeThrough',
            'subscript',
            'superscript', '|',
            'fontFamily',
            'fontSize',
            'color',
            'inlineStyle',
            'paragraphStyle', '|',
            'paragraphFormat',
            'align',
            'formatOL',
            'formatUL',
            'outdent',
            'indent', '-',
            'quote',
            'insertLink',
            'insertTable', '|',
            'specialCharacters',
            'emoticons',
            'insertHR',
            'clearFormatting',
            'selectAll',
            'applyFormat',
            'removeFormat', '|',
            'html',
            'help'
          ]
        },
        configDisabledEditor: {
          placeholderText: '',
          toolbarSticky: false, // para o cabeçalho nao descer junto com a tela
          toolbarButtons: [
            'fullscreen',
            'undo',
            'redo', '|',
            'bold',
            'italic',
            'underline',
            'strikeThrough',
            'subscript',
            'superscript', '|',
            'fontFamily',
            'fontSize',
            'color',
            'inlineStyle',
            'paragraphStyle', '|',
            'paragraphFormat',
            'align',
            'formatOL',
            'formatUL',
            'outdent',
            'indent', '-',
            'quote',
            'insertLink',
            'insertTable', '|',
            'specialCharacters',
            'emoticons',
            'insertHR',
            'clearFormatting',
            'selectAll',
            'applyFormat',
            'removeFormat', '|',
            'html',
            'help'
          ],
          events: {
            'froalaEditor.initialized': function (e, editor) {
              editor.edit.off();
            }
          }
        }
      }
    },
    computed: {
      updateFieldValue: {
        get: function() {
          return this.fieldValue;
        },
        set: function(newValue) {
          this.$emit('updateFieldValue', this.attr.columnName, newValue);
        }
      }
    },
    created() {
      sgsUtils.resolveRules(this.attr, this.rules);
    }
  }
</script>

<template>
  <div>
    <el-popover
      ref="popover"
      v-show="showHint"
      placement="top-start"
      width="200"
      trigger="hover"
      :content="hintValue">
    </el-popover>

    <el-form-item label="temp" :prop="attr.columnName" v-if="moduleType === 'form' || attr.type === 'filterText'">

      <span slot="label">
        {{label}} <i v-if="showHint && moduleType === 'form'" class="glyphicon glyphicon-question-sign" v-popover:popover />
      </span>

      <froala :config="config" v-model="updateFieldValue"></froala>

    </el-form-item>
    <div v-if="moduleType === 'show'">
      <label>{{label}}</label>
      <p>
        <froala :config="configDisabledEditor" v-model="updateFieldValue"></froala>
      </p>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderTextEditor.vue?667361f0